import { Label } from '@onwardtravelsolutions/package-react/Components';

type FieldProps = {
    id: string;
    label?: string | React.ReactNode;
    className?: string;
    children: React.ReactNode;
};

export default function Field({
    id,
    children,
    label = null,
    className = null,
}: FieldProps) {
    return (
        <div className={`space-y-2 ${className}`}>
            {label && (
                <Label
                    fieldId={`field-${id}`}
                    className='prose dark:text-neutral-100'
                >
                    {label}
                </Label>
            )}
            {children}
        </div>
    );
}
